import { z } from "zod";
import {
  dataStateSchema,
  financialClassificationSchema,
  freshnessSchema,
  qualitySchema,
  reconciliationSchema,
} from "./governance";
import { isoDateTimeSchema, jsonValueSchema, opaqueIdSchema, versionSchema } from "./primitives";

export const metricValueSchema = z
  .object({
    tenantId: opaqueIdSchema,
    definitionId: z.string().trim().min(1).max(100),
    definitionVersion: versionSchema,
    label: z.string().trim().min(1).max(200),
    value: z.union([z.number().finite(), z.string().trim().min(1), z.null()]),
    unit: z.string().trim().min(1).max(50).optional(),
    displayValue: z.string().trim().min(1).max(200),
    asOf: isoDateTimeSchema,
    dataState: dataStateSchema,
    freshness: freshnessSchema.default("UNKNOWN"),
    quality: qualitySchema,
    reconciliation: reconciliationSchema.default("UNKNOWN"),
    financialClassification: financialClassificationSchema.optional(),
    confidence: z.number().min(0).max(1).optional(),
    sourceSummary: z.string().trim().min(1).max(1_000),
    lineageReference: z.string().trim().min(1).max(500).optional(),
    dimensions: z.record(jsonValueSchema).default({}),
  })
  .strict()
  .superRefine((metric, context) => {
    if (metric.dataState === "UNAVAILABLE" && metric.value !== null) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["value"],
        message: "Unavailable metrics must use null, never a fabricated zero or value",
      });
    }
  });

export type MetricValue = z.infer<typeof metricValueSchema>;

